import { initializeApp } from 'firebase/app';
import { getFirestore, getDocs, collection } from 'firebase/firestore';
import { getAuth, signInWithEmailAndPassword, onAuthStateChanged } from "firebase/auth";
import { getStorage } from "firebase/storage";

// import vessels from "./assets/data/new-vessels.json";
// import members from "./assets/data/members.json";
// import press from "./assets/data/press.json";
// import careers from "./assets/data/careers.json";
// import clients from "./assets/data/clients.json";
// import offices from "./assets/data/new-offices.json";

// firebase init
const firebaseConfig = {
    apiKey: "AIzaSyCN0JZ4m8Zz5erqEenb00XKqoXv2Qm9BF8",
    authDomain: "swiss-marine.firebaseapp.com",
    projectId: "swiss-marine",
    storageBucket: "swiss-marine.appspot.com",
    messagingSenderId: "562946029263",
    appId: "1:562946029263:web:105f231c19188e1fa1a9ba",
    measurementId: "G-XZSXW6H5V9"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const signIn = signInWithEmailAndPassword;
const storage = getStorage(app);

const getData = async function(col) {
    const snapshot = await getDocs(collection(db, col));
    let data = [];

    snapshot.forEach((docRef) => {
        data.push({ 
            ...docRef.data(),
            id: docRef.id
        });
    });

    return data;
}

onAuthStateChanged(auth, (user) => {
    if (!user && window.location.href.indexOf('/admin/') > -1)  {
        window.location.href = '/admin';
    }
});

// Implement batches
// const batch = writeBatch(db);

// vessels.forEach((v) => {
//     let ref = doc(db, "vessels", v.name);
//     batch.set(ref, v);
// });

// members.forEach((v) => {
//     let ref = doc(db, "members", v.name);
//     batch.set(ref, v);
// });

// press.forEach((v) => {
//     let ref = doc(db, "press", v.title);
//     batch.set(ref, v);
// });

// careers.forEach((v) => {
//     let ref = doc(db, "careers", v.title);
//     batch.set(ref, v);
// });

// clients.forEach((v) => {
//     let ref = doc(db, "customers", v.logo);
//     batch.set(ref, {
//         url: "",
//         logo: v.logo + ".png",
//         visible: true,
//         name: v.logo,
//         orderId: v.id
//     });
// });

// offices.forEach((v) => {
//     let ref = doc(db, "contacts", v.name);
//     batch.set(ref, v);
// });

// let about = doc(db, "common", "aboutus");
// batch.set(about, {
//     content: "<p>SwissMarine was established in 2001 as a freight operator, offering transportation services on capes and panamax size vessels mainly to European based coal power stations and steel mills as well as miners for their raw material transportation needs. Over the years, SwissMarine has significantly expanded both in terms of size but also in its product offerings and became a well recognized brand in the industry.</p><p>Today, the company is headquartered in Singapore and operates out of five offices worldwide, Singapore, Geneva, Copenhagen, Verbier, and a representative office in Tokyo. The group has a professional staff of over 50 employees, operates a drybulk fleet of approximately 160 vessels (mainly capesize, babycape, panamax and supramax) and transports annually about 120 million metric tons of cargo worldwide.</p><p>On 13 September 2019, SwissMarine  and its subsidiaries were acquired by Singapore Marine Pte. Ltd., a company incorporated in Singapore by our former Managing Director and founder Peter Weernink together with a number of prominent investors: Golden Ocean, Ionic shipping, the Martinos family (Thenamaris), Angus Paul, Will Snellings (Marianas fund) and the Veniamis family (Golden Union Shipping).</p>"
// });

// let policy = doc(db, "common", "policy");
// batch.set(policy, {
//     content: "",
//     title: "Anti-Bribery, Corruption and Sanctions Policy"
// });

// let numbers = doc(db, "common", "numbers");
// batch.set(numbers, {
//     cargo: 126.6,
//     turnover: 1.48,
//     ships: 175
// });

// getData('customers').then((d) => {
//     d.forEach((c) => {
//         let ref = doc(db, "customers", c.name);

//         batch.update(ref, {
//             fileKey: c.name + '.png'
//         });
//     })

//     batch.commit();
// });

export {
    db,
    auth,
    signIn,
    storage,
    getData
}
